import React from "react";

import "./modalStyle.scss";

import SimManager from "../managers/simManager";

import Back from "@learningblocks/storybook-components/lib/Icons/back.svg";
import ElectronicScale from "../../../../../apps/new-era-sims/lib/diffusion-and-medicine/src/ElectronicScale/ElectronicScale";
import ElectronicScaleModal from "@learningblocks/storybook-components/lib/ElectronicScaleModal";
import TimeAnimationModal from "@learningblocks/storybook-components/lib/TimeAnimationModal";
import AnimationModal from "@learningblocks/storybook-components/lib/AnimationModal";
import OsmosisPoster from "../../../../../apps/new-era-sims/lib/diffusion-and-medicine/src/OsmosisPoster/OsmosisPoster";
import Timer from "../../../../../apps/new-era-sims/lib/diffusion-and-medicine/src/Timer/Timer";
import ProtocolOverview from "../../../../../apps/new-era-sims/lib/diffusion-and-medicine/src/ProtocolOverview/ProtocolOverview";
import Sorter from "@learningblocks/simulations/shared-components/lib/SorterView/sorter";
import { Thumbnail } from "@learningblocks/simulations/shared-components/lib/ResultsComparisonMicroscope/Thumbnail/thumbnail";

import ModalManager from "../managers/modalManager";
import { PrincipleOfSpectrophotometerModal } from "@learningblocks/storybook-components/lib/Spectrophotometer/PrincipleOfSpectrophotometerModal";
import { SpectrophotometerInfoModal } from "@learningblocks/storybook-components/lib/Spectrophotometer/SpectrophotometerInfoModal";
import { SpectrophotometerConfigModal } from "@learningblocks/storybook-components/lib/Spectrophotometer/SpectrophotometerConfigModal";
import { WhatIsLightModal } from "@learningblocks/storybook-components/lib/Spectrophotometer/SpectrophotometerWhatIsLightModal";
import { HoldTheCuvetteModal } from "@learningblocks/storybook-components/lib/Spectrophotometer/HoldTheCuvetteAnimationPopup";
import { SpectrophotometerTroubleshootModal } from "@learningblocks/storybook-components/lib/Spectrophotometer/SpectrophotometerTroubleshootModal";
import { SpectrophotometerMeasuringSampleModal } from "@learningblocks/storybook-components/lib/Spectrophotometer/SpectrophotometerMeasuringSampleModal";

import { MicroplateFocusModal } from "@learningblocks/storybook-components/lib/Microplate/MicroplateFocusModal";
import { MicroplateReaderFocusModal } from "@learningblocks/storybook-components/lib/Microplate/MicroplateReaderFocusModal";
import {
  NotebookManualModal,
  Component,
} from "@learningblocks/storybook-components/lib/NotebookManual";
import { SpectrophotometerFullSpectrumModal } from "@learningblocks/storybook-components/lib/Spectrophotometer/SpectrophotometerFullSpectrum";
import { SpectrophotometerManualModal } from "@learningblocks/storybook-components/lib/Spectrophotometer/SpectrophotometerManual";
import { InspectTubeModal } from "@learningblocks/storybook-components/lib/InspectTubeModal";
import { NotebookCalculatorModal } from "@learningblocks/simulations/shared-components/lib/ProtocolModals/Views/NotebookCalculatorModal/";
import { MicroscopeSorterNotebookModal } from "@learningblocks/simulations/shared-components/lib/ProtocolModals/Views/MicroscopeSorterNotebookModal";

export interface modalProps {
  modal: string;
}

class ModalJSXElement extends React.Component<modalProps> {
  state: {
    modalOpen: boolean;
    name: string;
    modalData: { data?: unknown };
  };
  displayBack: boolean;

  constructor(props: modalProps) {
    super(props);

    this.displayBack = true;

    this.state = {
      modalOpen: false,
      name: props.modal,
      modalData: {},
    };
    ModalManager.getInstance().registerModal(this, props.modal);
  }

  componentDidMount(): void {
    // this.componentRef.current?.externalFunction();
  }

  closeModal = () => {
    ModalManager.getInstance().closedModal(this.state.modalData);
    this.setState({ modalOpen: false });
  };

  openModal = (callback?: () => void, modalData: unknown = {}) => {
    this.setState({ modalOpen: true, modalData: modalData || {} }, callback);
  };

  createModal = (name: string) => {
    const modals: { key: string; Component: React.ComponentType<any> }[] =
      SimManager.getInstance().getModals();

    // Check if app registered a custom modal component first
    const registeredModal = modals.find((modal) => modal.key === name);
    if (registeredModal) {
      return React.createElement(registeredModal.Component, {
        isOpen: this.state.modalOpen,
        onClose: this.closeModal,
        show: this.state.modalOpen,
        close: this.closeModal,
        notebookCollapsed: false,
        ...((this.state.modalData as object) || {}),
      });
    }

    switch (name) {
      // case "VolumeModal": {
      // 	//@ts-ignore
      // 	const modalJS = (
      // 		<SpectrophotometerInfoModal
      // 			notebookCollapsed={false}
      // 			isOpen={this.state.modalOpen}
      // 			onClose={this.closeModal}
      // 			size="lg"
      // 		/>
      // 	);
      // 	return modalJS;
      // 	break;
      // }
      case "ElectronicScaleModal": {
        const modal = (
          <ElectronicScaleModal
            isOpen={this.state.modalOpen}
            onClose={this.closeModal}
            notebookCollapsed={false}
            {...(this.state.modalData as object)}
          />
        );
        return modal;
      }
      //Deprecated
      case "ElectronicScale": {
        const modal = (
          <ElectronicScale
            show={this.state.modalOpen}
            close={this.closeModal}
          />
        );
        return modal;
      }
      case "OsmosisPoster": {
        const modal = (
          <OsmosisPoster show={this.state.modalOpen} close={this.closeModal} />
        );
        return modal;
      }
      case "ProtocolOverview": {
        this.displayBack = false;
        const modal = (
          <ProtocolOverview
            show={this.state.modalOpen}
            close={this.closeModal}
          />
        );
        return modal;
      }
      case "Timer": {
        const modal = (
          <Timer show={this.state.modalOpen} close={this.closeModal} />
        );
        return modal;
      }
      case "PrincipleOfSpectrophotometerModal": {
        const modal = (
          <PrincipleOfSpectrophotometerModal
            isOpen={this.state.modalOpen}
            onClose={this.closeModal}
            notebookCollapsed={false}
          />
        );
        return modal;
      }
      case "SpectrophotometerInfoModal": {
        const modal = (
          <SpectrophotometerInfoModal
            isOpen={this.state.modalOpen}
            onClose={this.closeModal}
            notebookCollapsed={false}
          />
        );
        return modal;
      }
      case "SpectrophotometerConfigModal": {
        const modal = (
          <SpectrophotometerConfigModal
            isOpen={this.state.modalOpen}
            onClose={this.closeModal}
            notebookCollapsed={false}
          />
        );
        return modal;
      }
      case "WhatIsLightModal": {
        const modal = (
          <WhatIsLightModal
            isOpen={this.state.modalOpen}
            onClose={this.closeModal}
            notebookCollapsed={false}
          />
        );
        return modal;
      }
      case "LearnHowToHoldCuvette": {
        const modal = (
          <HoldTheCuvetteModal
            isOpen={this.state.modalOpen}
            onClose={this.closeModal}
          />
        );
        return modal;
      }
      case "TimeAnimationModal": {
        const modal = (
          <TimeAnimationModal
            isOpen={this.state.modalOpen}
            onClose={this.closeModal}
            {...(this.state.modalData as object)}
          />
        );
        return modal;
      }
      case "AnimationModal": {
        const modal = (
          <AnimationModal
            isOpen={this.state.modalOpen}
            onClose={this.closeModal}
            animation="osmosis"
            stopOnLastFrame={true}
            {...(this.state.modalData as object)}
          />
        );
        return modal;
      }
      case "SpectrophotometerTroubleshoot": {
        const modal = (
          <SpectrophotometerTroubleshootModal
            isOpen={this.state.modalOpen}
            onClose={this.closeModal}
            notebookCollapsed={false}
          />
        );
        return modal;
      }
      case "MicroplateFocusModal": {
        const modal = (
          <MicroplateFocusModal
            isOpen={this.state.modalOpen}
            onClose={this.closeModal}
            notebookCollapsed={false}
            size="lg"
            isDispense={false}
          />
        );
        return modal;
      }
      case "InspectTubeModal": {
        const modal = (
          <InspectTubeModal
            isOpen={this.state.modalOpen}
            onClose={this.closeModal}
            notebookCollapsed={false}
            size="lg"
            isDispense={false}
          />
        );
        return modal;
      }
      case "MicroplateDispenseFocusModal": {
        const modal = (
          <MicroplateFocusModal
            isOpen={this.state.modalOpen}
            onClose={this.closeModal}
            notebookCollapsed={false}
            size="lg"
            isDispense={true}
          />
        );
        return modal;
      }
      case "MicroplateReaderFocusModal": {
        const modal = (
          <MicroplateReaderFocusModal
            isOpen={this.state.modalOpen}
            onClose={this.closeModal}
            notebookCollapsed={false}
          />
        );
        return modal;
      }
      case "MeasuringSampleModal": {
        const modal = (
          <SpectrophotometerMeasuringSampleModal
            isOpen={this.state.modalOpen}
            onClose={this.closeModal}
            notebookCollapsed={false}
          />
        );
        return modal;
      }
      case "LabManual": {
        const modal = (
          <SpectrophotometerManualModal
            isOpen={this.state.modalOpen}
            onClose={this.closeModal}
            notebookCollapsed={false}
          />
        );
        return modal;
      }
      case "NotebookLabManual": {
        const modal = (
          <NotebookManualModal
            isOpen={this.state.modalOpen}
            onClose={this.closeModal}
            notebookCollapsed={false}
            data={
              this.state.modalData.data as {
                displayPageNum?: boolean;
                displayHeading?: boolean;
                displayDate?: boolean;
                label?: string;
                showNotebookGridBody?: boolean;
                components?: Component[];
              }
            }
            size="lg"
          />
        );
        return modal;
      }

      case "PlugMicroscopeIn": {
        const modal = (
          <AnimationModal
            isOpen={this.state.modalOpen}
            onClose={this.closeModal}
            animation="microscope_plug_in"
            ariaLabel="You plug the microscope into the wall socket."
            stopOnLastFrame={true}
            {...(this.state.modalData as object)}
          />
        );
        return modal;
      }

      case "WipeMicroscope": {
        const modal = (
          <AnimationModal
            isOpen={this.state.modalOpen}
            onClose={this.closeModal}
            animation="wipe"
            ariaLabel="The microscope lens as seen from above. You gently wipe it clean."
            stopOnLastFrame={true}
            {...(this.state.modalData as object)}
          />
        );
        return modal;
      }

      case "UnplugMicroscope": {
        const modal = (
          <AnimationModal
            isOpen={this.state.modalOpen}
            onClose={this.closeModal}
            animation="microscope_plug_out"
            ariaLabel="You unplug the microscope from the wall socket."
            stopOnLastFrame={true}
            {...(this.state.modalData as object)}
          />
        );
        return modal;
      }

      case "LenseAnimation1": {
        const modal = (
          <AnimationModal
            isOpen={this.state.modalOpen}
            onClose={this.closeModal}
            animation="lense_animation_1"
            ariaLabel="The microscope's nosepiece swivels to place one of the 3 lenses above the stage. "
            stopOnLastFrame={true}
            closeOnComplete={true}
            {...(this.state.modalData as object)}
          />
        );
        return modal;
      }

      case "LenseAnimation2": {
        const modal = (
          <AnimationModal
            isOpen={this.state.modalOpen}
            onClose={this.closeModal}
            animation="lense_animation_2"
            ariaLabel="The microscope's nosepiece swivels to place one of the 3 lenses above the stage."
            stopOnLastFrame={true}
            closeOnComplete={true}
            {...(this.state.modalData as object)}
          />
        );
        return modal;
      }

      case "LenseAnimation3": {
        const modal = (
          <AnimationModal
            isOpen={this.state.modalOpen}
            onClose={this.closeModal}
            animation="lense_animation_3"
            ariaLabel="The microscope's nosepiece swivels to place one of the 3 lenses above the stage."
            stopOnLastFrame={true}
            closeOnComplete={true}
            {...(this.state.modalData as object)}
          />
        );
        return modal;
      }

      case "SorterView": {
        const modal = (
          <Sorter
            isOpen={this.state.modalOpen}
            onClose={this.closeModal}
            notebookCollapsed={false}
          />
        );
        return modal;
      }

      case "ThumbnailModal": {
        const modal = (
          <Thumbnail
            isOpen={this.state.modalOpen}
            onClose={this.closeModal}
            notebookCollapsed={false}
          />
        );
        return modal;
      }
      case "NotebookCalculatorModal": {
        const modalData = this.state.modalData as any;
        if (!modalData?.data?.notebookData) {
          console.warn(
            "NotebookCalculatorModal: Missing required data (notebookData)"
          );
          return null;
        }
        const modal = (
          <NotebookCalculatorModal
            isOpen={this.state.modalOpen}
            onClose={this.closeModal}
            notebookCollapsed={false}
            data={{
              notebookData: modalData.data.notebookData,
            }}
          />
        );
        return modal;
      }
      case "MicroscopeSorterNotebookModal": {
        const modalData = this.state.modalData as any;
        if (
          !modalData?.data?.notebookData ||
          !modalData?.data?.microscopeSorterData
        ) {
          console.warn(
            "MicroscopeSorterNotebookModal: Missing required data (notebookData and microscopeSorterData)"
          );
          return null;
        }

        const microscopeMeiosisState =
          SimManager.getInstance().getState("microscopeMeiosis");

        if (microscopeMeiosisState === "empty") {
          modalData.data.microscopeSorterData.isEmpty = true;
        } else {
          modalData.data.microscopeSorterData.isEmpty = false;
        }
        const modal = (
          <MicroscopeSorterNotebookModal
            isOpen={this.state.modalOpen}
            onClose={this.closeModal}
            notebookCollapsed={false}
            data={{
              notebookData: modalData.data.notebookData,
              microscopeSorterData: modalData.data.microscopeSorterData,
            }}
          />
        );
        return modal;
      }
      case "FullSpectrum": {
        const modal = (
          <SpectrophotometerFullSpectrumModal
            isOpen={this.state.modalOpen}
            onClose={this.closeModal}
            notebookCollapsed={false}
          />
        );
        return modal;
      }
      case "Calculator": {
        this.displayBack = false;
        const modalComponent = modals.find(
          (modal: { key: string; Component: React.ComponentType<any> }) =>
            modal.key === "Calculator"
        )?.Component;
        const modal = modalComponent
          ? React.createElement(modalComponent, {
              isOpen: this.state.modalOpen,
              onClose: this.closeModal,
              notebookCollapsed: false,
              testId: "calculator-modal",
            })
          : null;
        return modalComponent ? modal : null;
      }
      case "Practice_Assessment_Modal": {
        const modalComponent = modals.find(
          (modal) => modal.key === "PracticeAssessmentModal"
        )?.Component;
        const modal = modalComponent
          ? React.createElement(modalComponent, {
              isOpen: this.state.modalOpen,
              onClose: this.closeModal,
              notebookCollapsed: false,
            })
          : null;
        return modal;
      }
      case "Notebook_Modal": {
        const modalComponent = modals.find(
          (modal) => modal.key === "Notebook_Modal"
        )?.Component;
        const modal = modalComponent
          ? React.createElement(modalComponent, {
              isOpen: this.state.modalOpen,
              onClose: this.closeModal,
              notebookCollapsed: false,
            })
          : null;
        return modal;
      }
      case "mitosis_poster": {
        this.displayBack = false;
        const modalComponent = modals.find(
          (modal) => modal.key === "Mitosis_Poster"
        )?.Component;
        const modal = modalComponent
          ? React.createElement(modalComponent, {
              isOpen: this.state.modalOpen,
              onClose: this.closeModal,
              notebookCollapsed: false,
            })
          : null;
        return modal;
      }
      default: {
        return <></>;
      }
    }
  };

  render() {
    const modalElement = this.createModal(this.props.modal);

    return (
      <div
        className="modalStyle"
        style={{
          display: this.state.modalOpen ? "block" : "none",
        }}
      >
        {modalElement}
        <div
          role="button"
          tabIndex={0}
          aria-label="Close modal"
          className={"BackButton"}
          onKeyDown={this.closeModal}
          onClick={this.closeModal}
          style={{
            height: "10%",
            position: "fixed",
            top: "16px",
            left: "16px",
            transform: "translate3d(0, 0, 0px);",
            display: this.displayBack ? "block" : "none",
            zIndex: 99,
          }}
        >
          <div
            style={{
              width: "66px",
              paddingLeft: "32px",
              paddingRight: "32px",
              paddingTop: "18px",
              paddingBottom: "16px",
              marginLeft: "16px",
              marginTop: "16px",
              background: "white",
              borderRadius: "5px",
              justifyContent: "center",
              alignItems: "center",
              gap: "8px",
              display: "inlineFlex",
            }}
          >
            <img src={Back} width={"16px"} height={"16px"} alt={"Back"}></img>
            <div
              style={{
                position: "relative",
                top: "-2px",
                display: "inline-block",
                textAlign: "center",
                color: "#0063C3",
                fontSize: "18px",
                fontFamily: "Bio Sans",
                fontWeight: "400",
                wordWrap: "break-word",
                width: "50px",
              }}
            >
              Back
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ModalJSXElement;
